export default __webpack_public_path__ + "static/media/198property-gallery4.3382260b.webp";